import React, { ReactElement, useState, useEffect, createRef, useRef } from 'react'
import { Table, Button, Modal, notification, Form, Row, Col, Input, Space, Popover, Select } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import type { FormInstance } from 'antd/es/form/Form'
import type { PaginationProps } from 'antd'
import { SmileOutlined } from '@ant-design/icons'
import { getProjectInfoList } from '@/services/table.service'
import { IPagination, IProjectInfo, IProjectInfoResData } from '@/store/models/tableEdit.model'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
// import type { IColProperty } from '@/pages/table2SearchAll'
import { wrapText } from '@/pages/table2SearchAll'
import type { IAppState } from '@/store/reducers'
import { getTechClassification } from '@/store/actions/tableEdit.action'


// type EditableTableProps = Parameters<typeof Table>[0]
// type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>

export default function SelectTechListPop({
    show,
    hide,
    checked,
    maturityStatus,
    addTechReview,
    selectionKey,
    setSelectionKey,
    selectRecord,
    setSelectRecord
}: {
    show: boolean
    hide: any
    checked?: boolean
    maturityStatus?: boolean
    addTechReview?: boolean
    selectionKey?: any
    setSelectionKey?: any
    selectRecord?: any
    setSelectRecord?: any
}): ReactElement {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [selectObj, setSelectObj] = useState<any>(null)
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [tableKey, setTableKey] = useState<string>('a')
    const [loading, setLoading] = useState(false)
    const [dataSource, setDataSource] = useState<any[]>([])
    const [selectionType, setSelectionType] = useState<'checkbox' | 'radio'>('radio')
    // const [selectionKey, setSelectionKey] = useState<any[]>([])
    const [winH, setWinH] = useState(0)
    const { Option } = Select
    const [paginationInfo, setPaginationInfo] = useState<IPagination>({
        pageIndex: 1,
        pageSize: 6,
        total: 0
    })
    const [initFlg, setInitFlg] = useState(true)
    const classification = useSelector((state: IAppState) => state.tableEditData.techClassification)
    const [workClassArr, setWorkClassArr] = useState<any[]>([])
    const [searchValues, setSearchValues] = useState<any>({})
    // const [selectionKey, setSelectionKey] = useState<any[]>([])
    // const [selectRecord, setSelectRecord] = useState<any>()
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)

    useEffect(() => {
        if (initFlg) return
        const _classification = [...classification]
        const groupByCategory = _classification.reduce((group: any, product) => {
            const { classId } = product
            group[classId] = group[classId] || []
            group[classId].push(product)
            return group
        }, {})
        const _classArr: any[] = []
        Object.keys(groupByCategory).forEach(key => {
            _classArr.push(groupByCategory[key][0])
        })
        setWorkClassArr([..._classArr])
    }, [classification])

    const changeWorkGroup = (e: any) => {
        setInitFlg(false)
        dispatch(getTechClassification({
            pageNo: 1,
            pageSize: 100,
            workGroupId: e
        }))
    }
    const formRef = createRef<FormInstance>()
    // pageSize 变更后，会重复触发 pageChange 事件
    const pageSizeChanged = useRef<boolean>(false)
    const closePop = () => {
        hide()
    }
    const columns: any = [
        {
            title: () => <span>{t('Work Group')}</span>,
            dataIndex: 'techClass',
            key: 'techClass',
            width: 150,
            ellipsis: { showTitle: true },
            fixed: true,
            render(value:any) {
                return value.workGroup.workGroupName
            }
        },
        {
            title: () => <span>{t('Classification')}</span>,
            dataIndex: 'classificationName',
            key: 'classification',
            width: 150,
            ellipsis: { showTitle: true },
            fixed: true,
        },
        {
            title: () => <span>{t('PTN')}</span>,
            dataIndex: 'techPtn',
            key: 'techPtn',
            width: 150,
            className: 'lang_column',
            ellipsis: { showTitle: true },
            fixed: true,
            render: wrapText
        },
        {
            title: () => <span>{t('researchForms')}</span>,
            dataIndex: 'researchForms',
            key: 'researchForms',
            width: 150,
            className: 'search_col lang_column',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('Technology Name')}</span>,
            dataIndex: 'techName',
            key: 'technologyName',
            width: 180,
            className: 'lang_column',
            ellipsis: { showTitle: true },
            render(value:any) {
                if (value && (value.includes('<div') || value.includes('<span'))) {
                    return <Popover
                        title=""
                        content={
                            <div dangerouslySetInnerHTML={{
                                __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
                            }}></div>
                        }
                    >
                        <div style={{ maxWidth: 180 }}
                            className='table_ellipsis' dangerouslySetInnerHTML={{
                                __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
                            }}
                        ></div>
                    </Popover>
                } else {
                    return <div style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}
                        title={value}
                    >
                        {wrapText(value)}
                    </div>
                }
            }
        },
        {
            title: () => <span>{t('subsidiary')}</span>,
            dataIndex: 'subsidiary',
            key: 'subsidiary',
            width: 150,
            className: 'lang_column',
            ellipsis: { showTitle: true },
            render(value:any) {
                if (value && (value.includes('<div') || value.includes('<span'))) {
                    return <div
                        dangerouslySetInnerHTML={{
                            __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
                        }}
                    ></div>
                } else {
                    return <div style={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis' }}
                        title={value}
                    >
                        {wrapText(value)}
                    </div>
                }
            }
        },
        {
            title: () => <span>{t('description')}</span>,
            dataIndex: 'description',
            width: 280,
            ellipsis: { showTitle: true },
            key: 'description',
            render(value:any) {
                if (value && (value.includes('<div') || value.includes('<span'))) {
                    return <Popover
                        placement="topLeft"
                        title=""
                        content={
                            <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                                dangerouslySetInnerHTML={{
                                    __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
                                }}
                            ></div>
                        }
                    >
                        <div style={{ maxWidth: 240 }}
                            className='table_ellipsis'
                            dangerouslySetInnerHTML={{
                                __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
                            }}
                        ></div>
                    </Popover>
                } else {
                    return <div style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis' }}
                        title={value}
                    >
                        {wrapText(value)}
                    </div>
                }
            }
        },
        {
            title: () => <span>{t('techLevel')}</span>,
            dataIndex: 'techLevel',
            key: 'techLevel',
            width: 100,
            className: 'search_col lang_column',
            ellipsis: { showTitle: true },
            render(value:any) {
                return [t('core'), t('key'), t('general'), t('normal')][value - 1]
            }
        },
        {
            title: () => <span>{t('priority')}</span>,
            dataIndex: 'priority',
            key: 'priority',
            width: 100,
            className: 'lang_column',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('quantitativeIndicators')}</span>,
            dataIndex: 'quantitativeIndicators',
            key: 'quantitativeIndicators',
            width: 280,
            ellipsis: { showTitle: true },
            render(value:any) {
                if (value && (value.includes('<div') || value.includes('<span'))) {
                    return <Popover
                        placement="topLeft"
                        title=""
                        content={
                            <div dangerouslySetInnerHTML={{
                                __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
                            }}></div>
                        }
                    >
                        <div style={{ maxWidth: 240 }}
                            className='table_ellipsis'
                            dangerouslySetInnerHTML={{
                                __html: (value.includes('"str":') && value.includes('"obj":')) ? JSON.parse(value).str : value
                            }}
                        ></div>
                    </Popover>
                } else {
                    return <div style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis' }}
                        title={value}
                    >
                        {wrapText(value)}
                    </div>
                }
            }
        },
        {
            title: () => <span>{t('tmtApproval')}</span>,
            dataIndex: 'tmtapproval',
            key: 'TMTApproval',
            width: 100,
            className: 'green_column',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('maturity')}</span>,
            dataIndex: 'maturity',
            key: 'maturity',
            width: 150,
            className: 'green_column',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('requirementSource')}</span>,
            dataIndex: 'requirementSource',
            key: 'requirementSource',
            width: 150,
            className: 'green_column',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('developedBy')}</span>,
            dataIndex: 'developedBy',
            key: 'developedBy',
            width: 150,
            className: 'green_column',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('buStakeholder')}</span>,
            dataIndex: 'buStakeholder',
            key: 'buStakeholder',
            width: 150,
            className: 'green_column',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('toolsEquipment')}</span>,
            dataIndex: 'toolsEquipment',
            key: 'toolsEquipment',
            width: 150,
            className: 'green_column',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('resourceNeeded')}</span>,
            dataIndex: 'resourceNeeded',
            key: 'resourceNeeded',
            width: 200,
            className: 'green_column',
            ellipsis: { showTitle: true },
        },
    ]
    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    }
    const tailLayout = {
        wrapperCol: { offset: 7, span: 10 },
    }
    const getList = async (params: any) => {
        try {
            setLoading(true)
            if (maturityStatus) {
                params.maturity = ['DEVELOPING', 'PLANNING', 'RELEASED']
            }
            if (addTechReview) {
                params.deliveryReview = ['Failure', '-']
            }
            params.isAll = true
            const res = await getProjectInfoList({
                ...params,
                pageNo: params?.pageIndex || paginationInfo.pageIndex,
                pageSize: params?.pageSize || paginationInfo.pageSize,
            }).finally(() => {
                setLoading(false)
            })
            console.log('getList: ', res)
            const content = res.content as IProjectInfoResData[]
            const projectInfoList = content.map(item => {
                const newItem: IProjectInfo = {
                    ...item,
                    techClassId: item.techClass.id,
                    classificationName: item.techClass.classificationName
                }
                item.techYearQuarters.forEach(yearItem => {
                    newItem[`${String(yearItem.year).substring(2)}-Q${yearItem.quarter}id`] = yearItem.id
                    newItem[`${String(yearItem.year).substring(2)}-Q${yearItem.quarter}`] = yearItem.status
                })
                return newItem
            })
            setDataSource([...projectInfoList])
            setPaginationInfo({
                pageIndex: params?.pageIndex || paginationInfo.pageIndex,
                pageSize: params?.pageSize || paginationInfo.pageSize,
                total: res.totalElements
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // 分页
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber: number): void => {
        if (pageSizeChanged.current) return
        getList({
            ...searchValues,
            ...paginationInfo,
            pageIndex: pageNumber
        })
    }
    const onPageSizeChange = (current: number, size: number) => {
        // 避免重复触发 pageChange 事件
        pageSizeChanged.current = true
        getList({
            ...searchValues,
            ...paginationInfo,
            pageIndex: current,
            pageSize: size
        })

        setTimeout(() => {
            pageSizeChanged.current = false
        }, 100)
    }

    const rowSelection = {
        onSelect: (record: IProjectInfo) => {
            const findIndex = selectionKey.findIndex((item: any) => item === record.id)
            if (findIndex > -1) {
                selectionKey.splice(findIndex, 1)
                selectRecord.splice(findIndex, 1)
                setSelectionKey([...selectionKey])
                setSelectRecord([...selectRecord])
            } else {
                if (selectionKey && Object.prototype.toString.call(selectionKey) === '[object Array]') {
                    setSelectionKey([...selectionKey, record.id])
                } else {
                    setSelectionKey([record.id])
                }
                if (selectRecord && Object.prototype.toString.call(selectRecord) === '[object Array]') {
                    setSelectRecord([...selectRecord, record])
                } else {
                    setSelectRecord([record])
                }
            }
        },
        onChange: (selectedRowKeys: React.Key[], selectedRows: IProjectInfo[]) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
            if (!checked) {
                for (const record of selectedRows) {
                    setSelectionKey([record.id])
                    setSelectRecord(record)
                }
            }
        },
    }
    const onFinish = async (values: any) => {
        console.log('onFinish: ', values)
        setSearchValues(values)
        getList({
            ...values,
            ...paginationInfo,
            pageIndex: 1,
        })
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any }) => {
        console.log('onFinishFailed: ', errorFields)
        if (errorFields.length) {
            const args = {
                message: t('FinishFailed'),
                description: '',
                icon: <SmileOutlined style={{ color: '#e1931e' }} />,
                duration: 3,
            }
            notification.open(args)
        }
    }
    const onReset = () => {
        formRef.current?.resetFields()
    }
    const onConfirm = () => {
        if (selectRecord) {
            hide(selectRecord)
        }
    }

    useEffect(() => {
        getList(paginationInfo)
        const offsetH = 360
        setWinH(document.body.clientHeight - offsetH)
        const onResize = () => {
            setWinH(document.body.clientHeight - offsetH)
        }
        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [])
    useEffect(() => {
        console.log('winH: ', winH)
    }, [winH])
    useEffect(() => {
        if (show) {
            if (checked) {
                setSelectionType('checkbox')
            } else {
                setSelectionType('radio')
            }
        }
    }, [show])

    return (
        <Modal title={t('selectTech')} visible={show}
            maskClosable={false}
            onOk={onConfirm}
            onCancel={closePop}
            width='90%'
            centered
            okText={t('confirm')}
            cancelText={t('cancel')}
        >
            <Form {...layout} ref={formRef}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="edit_table"
            >
                <Row>
                    <Col span={12}>
                        <Form.Item name="workGroupId" label={<span className='label'>{t('Work Group')}</span>}
                        >
                            <Select allowClear placeholder={t('Work Group Placeholder')} onChange={changeWorkGroup}>
                                {
                                    workgroupList.map(item => {
                                        return <Option key={item.id} value={item.id}>{item.groupName}</Option>
                                    })
                                }
                            </Select>
                        </Form.Item>

                    </Col>
                    <Col span={12}>
                        <Form.Item name="techClassId" label={<span className='label'>{t('Classification')}</span>}>
                            <Select placeholder={t('Classification Placeholder')} style={{ width: '100%' }} allowClear mode="multiple">
                                {
                                    workClassArr.map(item => (
                                        <Option value={item.classId} key={item.classId}
                                            title={item.classificationName}
                                        >{item.classificationName}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="techPtn" label={<span className='label'>{t('PTN')}</span>}>
                            <Input placeholder={t('PTN Placeholder')} allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="techName" label={<span className='label'>{t('Technology Name')}</span>}>
                            <Input placeholder={t('Tech Name Placeholder')} allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                    <Space size={20}>
                        <Button type="primary" htmlType="submit">{t('search')}</Button>
                        <Button htmlType="button" onClick={onReset}>{t('reset')}</Button>
                    </Space>
                </Form.Item>
            </Form>
            <Table key={tableKey} scroll={{ x: '100%', y: winH }} bordered
                dataSource={dataSource}
                columns={columns}
                loading={loading}
                childrenColumnName='xxx'
                rowKey='id'
                rowSelection={{
                    type: selectionType,
                    selectedRowKeys: selectionKey,
                    ...rowSelection,
                }}
                onRow={(record) => {
                    return {
                        onClick: () => {
                            if (checked) {
                                const findIndex = selectionKey.findIndex((item: any) => item === record.id)
                                if (findIndex === -1) {
                                    if (selectionKey && Object.prototype.toString.call(selectionKey) === '[object Array]') {
                                        setSelectionKey([...selectionKey, record.id])
                                    } else {
                                        setSelectionKey([record.id])
                                    }
                                    if (selectRecord && Object.prototype.toString.call(selectRecord) === '[object Array]') {
                                        setSelectRecord([...selectRecord, record])
                                    } else {
                                        setSelectRecord([record])
                                    }
                                } else {
                                    selectionKey.splice(findIndex, 1)
                                    selectRecord.splice(findIndex, 1)
                                    setSelectionKey([...selectionKey])
                                    setSelectRecord([...selectRecord])
                                }
                            } else {
                                setSelectionKey([record.id])
                                setSelectRecord(record)
                            }
                        }
                    }
                }}
                pagination={{
                    current: paginationInfo.pageIndex,
                    pageSize: paginationInfo.pageSize,
                    total: paginationInfo.total,
                    showQuickJumper: true,
                    onChange: onPaginationChange,
                    showSizeChanger: true,
                    onShowSizeChange: onPageSizeChange,
                    showTotal: (total) =>
                        `${t('total')} ${total} ${t('items')}`
                }}
            />
        </Modal>
    )
}
